import { sendRequest } from '../../utils/http-request';

export async function submit(
  accountNumber: string,
  bankAccountName: string,
  bankAccountBsb: string,
  bankAccountNumber: string,
  accountNumbers: string[],
  bankBranchName: string
) {
  return sendRequest('post', `billing/direct-debit/${accountNumber}`, {
    accountNumbers: accountNumbers,
    bankAccountName,
    bankAccountBsb,
    bankAccountNumber,
    bankName: bankBranchName,
  });
}
